



































































import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { repositories } from "@service/api/Repositories";
import { AgoraVirtualBackground } from "@share/web-conferences/agora/AgoraVirtualBackground";
import { AgoraVirtualBackgroundEffect } from "@share/web-conferences/enums/AgoraVirtualBackgroundEffect";
import { DeviceTestState } from "@share/web-conferences/types/DeviceTestState";
import { VirtualBackgroundEffectOptions } from "agora-extension-virtual-background";
import AgoraRTC, { ILocalVideoTrack } from "agora-rtc-sdk-ng";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { BackgroundImageService, ImageState } from "./BackgroundImageService";
import SelectButton from "./SelectButton.vue";
import ImageComponent from "./ImageComponent.vue";
import { releaseTrack } from "@share/web-conferences/helpers/TracksHelper";

@Component({ components: { SelectButton, ImageComponent } })

export default class BackgroundSelect extends Vue {

    @Prop() backgroundEffect: VirtualBackgroundEffectOptions | null;

    AgoraVirtualBackgroundEffect = AgoraVirtualBackgroundEffect;
    agoraVirtualBackground: AgoraVirtualBackground | null = null;
    backgroundImageService: BackgroundImageService = new BackgroundImageService(repositories.get(RepositoryFabric.FILE), this.lsKey);
    videoTrack: ILocalVideoTrack | null = null;

    selectedEffect: VirtualBackgroundEffectOptions & { imageId?: string } | null = null;

    async mounted() {
        //set selected background effect
        this.selectedEffect = this.backgroundEffect;
        this.playVideo();

        this.backgroundImageService.restore(this.backend);

        if (this.selectedEffect?.imageId) {
            Vue.set(this.allImages[this.selectedEffect?.imageId], "active", true);
        }
    }

    /**
     * Select background image effect
     * @param image
     */
    selectImage(image: ImageState) {

        if(image.error || image.onLoad) {
            return
        }

        if (image.id !== this.selectedImageId && image.url) {

            this.resetSelectedImage();

            Vue.set(image, "active", true);

            const source = document.createElement("img");
            source.crossOrigin = "anonymous";

            source.onload = async () => {
                try {
                    this.selectedEffect = { type: AgoraVirtualBackgroundEffect.img, source: source, imageId: image.id };
                    this.agoraVirtualBackground?.applyEffect(this.selectedEffect);
                } catch (e) {
                    this.$store.dispatch('reportError', e);
                }
            }

            source.src = image.url + '?';
        }
    }

    /**
     * Set blur effect
     */
    setBlur() {
        try {
            if (this.selectedEffect?.type !== AgoraVirtualBackgroundEffect.blur) {

                this.selectedEffect = { type: AgoraVirtualBackgroundEffect.blur };
                this.agoraVirtualBackground?.applyEffect(this.selectedEffect);

                this.resetSelectedImage();
            }
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
    }

    /**
     * disable any effects
     */
    disableBackground() {
        this.agoraVirtualBackground?.disable();

        this.resetSelectedImage();
        this.selectedEffect = null;
    }

    /**
     * file select handler
     */
    async onFileSelected(filesRaw: File[]) {
        const files = Array.from(filesRaw);
        const file = files[0];

        try {
            const image = await this.backgroundImageService.add(file, this.backend);

            if(image) {
                this.selectImage(image);
            }
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
    }

    /**
     * remove image
     */
    async removeImage(image: ImageState) {
        //save selectedId because it will removed in deleteFile method
        try {
            const selectedId = this.selectedImageId;

            await this.backgroundImageService.deleteFile(image);

            if (selectedId === image.id) {
                this.disableBackground();
            }
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
    }

    /**
     * retry upload
     */
    async retryUpload(image: ImageState) {
        const createdImage = await this.backgroundImageService.retryUpload(image, this.backend);

        if (createdImage) {
            this.selectImage(createdImage);
        }
    }

    /**
     * Need to start showing video in special container "video"
     */
    private async playVideo() {
        if (!this.selectedVideoDeviceId) {
            return
        }

        try {
            this.videoTrack = await AgoraRTC.createCameraVideoTrack({ cameraId: this.selectedVideoDeviceId });
        } catch (e) {
            this.videoTrack = null;
        }

        if (this.videoTrack) {
            const VirtualBackgroundExtension = (await import(/* webpackChunkName: "virtualbackground" */"agora-extension-virtual-background")).default;
            this.agoraVirtualBackground = new AgoraVirtualBackground(new VirtualBackgroundExtension(), this.videoTrack)
        }

        if (this.videoTrack && this.$refs['video'] && !this.videoTrack.isPlaying) {
            this.videoTrack?.play(this.$refs['video'] as HTMLElement);
        }

        //apply effect if it exist
        if (this.selectedEffect) {
            this.agoraVirtualBackground?.applyEffect(this.selectedEffect);
        }
    }

    /**
     * set current active to unactive
     */
    private resetSelectedImage() {
        if (this.selectedImageId) {
            Vue.set(this.allImages[this.selectedImageId], "active", false);
        }
    }

    @Watch('selectedVideoDeviceId')
    //it need for playing video after defining the video device
    watchSelectedVideoDeviceId(value: string) {
        if (value) {
            this.playVideo();
        }
    }

    beforeDestroy() {
        this.videoTrack?.stop();
        this.backgroundImageService.destroy();
        this.agoraVirtualBackground?.destroy();
        releaseTrack(this.videoTrack);
    }

    get selectedImageId() {
        const object = this.allImages;
        let activeId = null
        for (const key in object) {
            if (Object.prototype.hasOwnProperty.call(object, key) && object[key].active) {
                activeId = object[key].id
                break;
            }
        }
        return activeId;
    }

    get selectedVideoDeviceId() {
        return this.deviceTestState.selectedDevices.videoDeviceId;
    }

    get deviceTestState(): DeviceTestState {
        return this.$store.state.webConference.deviceTestState;
    }

    get allImages() {
        return {...this.images, ...this.restoredImages}
    }

    get restoredImages() {
        return this.backgroundImageService.restoredImages;
    }

    get images(): Record<string, ImageState> {
        return this.backgroundImageService.images;
    }

    get lsKey() {
        return `${process.env.VUE_APP_SERVER}_background-images_${this.backend}_${this.$store.state.session.userId}`;
    }

    get backend() {
        return this.$store.state.session.backend;
    }
}

